import { createAction } from '@reduxjs/toolkit';

export const clearPreoffersItemsAction = createAction('preoffers/clear');
